import React from "react";
import "./PayoutCPCheckerDashBoard.css";
import { Col, Row } from "react-bootstrap";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { Routes, Route, redirect, Navigate } from "react-router-dom";
import useWindowSize from "../../utils/useWindowSize";
import PayoutCheckerMobileHeader from "./PayoutCPCheckerMobileHeader";
import CustomLogout from "../CustomLogout/CustomLogout";
import { connect } from "react-redux";
// import PricingManagement from "../PricingManagement/PricingManagement";
// import PricingviewData from "../PricingManagement/PricingCreate/PricingviewData";
import PayoutManagementCPChecker from "../PayoutManagement/PayoutManagementCPChecker";
import LanListbypartnerCPChecker from "../PayoutManagement/PayoutListDetailsCPChecker/LanListbypartnerCPChecker";
import PayoutCPCheckerDashboardList from "./PayoutCPCheckerDashboardList";
import PayoutCPCheckerMobileHeader from "./PayoutCPCheckerMobileHeader";
import PartnerListDetailsCPChecker from "../PayoutManagement/PayoutListDetailsCPChecker/PartnerListDetailsCPChecker";
import LanListDetailChanalwise from "../PayoutManagement/payouLanlistDetailschanalwise/LanListDetailChanalwise";
import ChanalWiseReportCetChecker from "../PayoutManagement/ChanalWiseReportCetChecker";
import ChanalWiseReportCppChecker, { ChanalWiseReportCpChecker } from "../PayoutManagement/ChanalWiseReportCppChecker";
import LanlistCPDetailChannel from "../PayoutManagement/payouLanlistDetailschanalwise/LanlistCPDetailChannel";
// import EditPartner from "../PartnerManagement/EditPartner/EditPartner";

// const PartnerManagement = React.lazy(() =>
//   import("../PartnerManagement/PartnerManagement")
// );

// const EditPartner = React.lazy(() =>
//   import("../PartnerManagement/EditPartner/EditPartner")
// );

const RedirectToGenerateReport = () => {
  return <Navigate to="/PartnerPayout/generate-report" replace />;
};

const routes = [

  {
    path: "/PartnerPayout",
    element: <PayoutManagementCPChecker />,
  },
  {
    path: "/PartnerPayout/payout-report",
    element: <PayoutManagementCPChecker />,
  },
  {
    path: "/PartnerPayout/payout-report/Details/:fileName/:monthlyReportId",
    element: <PartnerListDetailsCPChecker />,
  },
  {
    path: "/PartnerPayout/payout-report/Details/:fileName/:monthlyReportId/landata/:partner",
    element: <LanListbypartnerCPChecker />,
  },
 
  {
      path: "/PartnerPayout/generate-report-channelwise",
      element:<ChanalWiseReportCppChecker/>,
  },
  {
      path: "/PartnerPayout/generate-report-channelwise/Details/:fileName/:reportId",
      element: <LanlistCPDetailChannel />,
  },
  
];

const PayoutCPCheckerDashboard = (props) => {
  const { width } = useWindowSize();
  return (
    <div>
      {props?.LogoutFlag?.logoutFlag ? <CustomLogout /> : ""}
      {width < 786 && (
        <Row>
          <Col lg={12} xs={12} md={12} sm={12} className="dashboard-cet-mobile">
            <PayoutCPCheckerMobileHeader />
          </Col>
        </Row>
      )}
      <Row>
        <Col lg={12} xs={12} md={12} sm={12} className="dashboard-content">
          <Col md={3} className="Left-side-blue">
            <PayoutCPCheckerDashboardList />
          </Col>

          <Col md={9} className="right-side-blue">
            <React.Suspense
              fallback={
                <div className="cet-dashobard-loader">
                  <Spin
                    className="cet-loader"
                    indicator={<LoadingOutlined style={{ color: "#00d8db" }} />}
                  ></Spin>
                </div>
              }
            >
              <Routes>
                {routes.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.element}
                  />
                ))}
              </Routes>
            </React.Suspense>
            {/* <Routes>
              {routes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
            </Routes> */}
            <Routes>
              {/* <Route
                path="/PartnerManagement"
                element={<PartnerManagement />}
              />
              <Route path="/edit-partner/:id" element={<EditPartner />} /> */}

              {/* <Route path="/leadManagement" element={<LeadManagements />} /> */}
            </Routes>
          </Col>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    LogoutFlag: state.Logout,
  };
};

export default connect(mapStateToProps)(PayoutCPCheckerDashboard);
